<template>
  <div class="form_combination">
    <el-form
      ref="formData"
      :model="formData"
      size="medium"
      :label-width="labelWidth?labelWidth:'120px'">
      <el-col
        v-for="(item,index) in formData"
        :span="item.col"
        :offset="item.offset"
        :key="index"
      >
        <template v-if="typeof item.displayWith == 'function'?item.displayWith(formData, item):!item.displayWith">
          <el-form-item v-bind="item" :prop="getProp(item,index)">
            <component
              :is="item.formType"
              v-model="item.value"
              v-bind="item"
              @change="typeof item.change== 'function'?item.change(formData,item):function(){}"
            ></component>
          </el-form-item>
        </template>
      </el-col>
      <slot></slot>
      <el-col style="margin-left:100px" v-if="showBtn">
        <el-button type="primary" @click="sure()" :loading="loading">确定</el-button>
        <el-button @click="reset('formData')">重置</el-button>
      </el-col>
    </el-form>
  </div>
</template>
<script>
import formComponent from "@/components/formComponents/index.js";
export default {
  name: "form_combination",
  props: ["formData", "showBtn", "labelWidth"],
  components: { ...formComponent },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    getProp(item, idx) {
      return `${idx}.value`;
    },
    validate(cb) {
      this.$refs.formData.validate(valid => {
        cb && cb(valid);
      });
    },
    sure() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          this.$emit("submit");
        }
      });
    },
    reset(val) {
      this.$refs[val].resetFields();
    }
  }
};
</script>
<style lang="scss">
.form_combination {
  .el-form {
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    .el-form-item {
      margin-bottom: 20px;
    }
    .el-form-item__label {
      padding-right: 20px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/formComponents/form-component.vue